/**
 * PageFooter — the locked per-page footer (one per page, rendered inside the Outlet). Owning the footer
 * per-page (not in AppShell) avoids a double footer; the design-system hard rule "footer present" is met
 * by every page rendering this once at the bottom of its content.
 */
import { SkyText } from "@skypointcloud/skypoint-ui";

export function PageFooter() {
  return (
    <footer className="mt-8 border-t border-neutral-200 pt-4">
      <SkyText size={200}>Skypoint skyCare. For authorized use only.</SkyText>
    </footer>
  );
}
